<template>
  <div>
    <label class="form-label">Points</label>
    <div class="vx-col">
      <vs-input-number min="1" v-model="points" style="width: 100px" />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: ["action", "automationId"],
  data() {
    return {
      points: 1,
    };
  },
  methods: {
    render() {
      return {
        points: parseInt(this.points),
      };
    },
  },
  computed: {
    ...mapGetters({
      triggerTypes: "automations/triggerTypes",
    }),
  },
  async mounted() {
    if (this.action && this.action.points) {
      this.points = parseInt(this.action.points);
    }
  },
};
</script>

<style lang="scss">
</style>


<style lang="scss" scoped>
.form-label {
  margin-bottom: 0.5rem;
  color: #5e5873;
  font-size: 0.857rem;
}
</style>